import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

class FinalAnalytics extends BaseAnalytics {
    constructor(category: string) {
        super();
        this.category = category;
    }

    clickPayment() {
        this.send('click payment');
    }

    clickCallTouch() {
        this.send('click calltouch');
    }

    clickChat() {
        this.send('click chat');
    }
}

export default FinalAnalytics;
